export const extConfig = {
    bold: true,
    italic: true,
    strikethrough: true,
    underline: true,
    bulletList: true,
    orderedList: true,
    horizontalRuler: true,
    link: true,
    emote: true,
    gif: {
        defaultWidth: 780,
        canAlign: true,
        defaultAlignment: 'center'
    },
    deviation: {
        defaultWidth: Infinity,
        formMaxWidth: 1920,
        canAlign: true,
        canLink: true
    },
    deviationThumb: {
        defaultWidth: 150,
        canLink: true,
        maxHeight: 600,
        maxWidth: 780
    },
    allowUploads: true,
    daVideo: {
        canAlign: true,
        defaultWidth: 3840,
        defaultHeight: 2160
    },
    gallery: {
        defaultWidth: Infinity,
        defaultAlignment: 'center',
        defaultGridItemWidth: 250,
        defaultGridItemHeight: 200,
        defaultLayout: 'grid',
        defaultTorpedoRowHeight: 200,
        defaultLayoutSpacing: 8,
        canLink: true,
        formMaxWidth: 1920
    },
    anchor: true,
    spinner: true,
    blockDragging: true,
    blockquote: true,
    heading: true,
    hashtag: true,
    mention: true,
    paste: true,
    textAlignment: true,
    textColor: true,
    textFont: true,
    textHighlight: true,
    history: true,
    indent: {
        captureTab: true
    },
    muro: true,
    characterCount: false
};

//# sourceMappingURL=config.js.map